import { Injectable } from "@angular/core";
import { select, Store } from "@ngrx/store";
import { State } from "app/reducers";
import {
    AddUserToBlock,
    ChangeFollowStatus,
    ChangeFollowStatusSuccess,
    ClearAll,
    ClearChatHistory,
    DeselectContact,
    GetFollowStatus,
    GetFollowStatusSuccess,
    GetRecentlyRecords,
    GetRecentlyRecordsByUser,
    GetRecentlyRecordsByUserComplete,
    GetRecentlyRecordsComplete,
    GetSettings,
    GetSettingsSuccess,
    LoadPreviousRecords,
    MarkAllMessagesAsRead,
    MarkMessagesAsRead,
    MessageReceived,
    RemoveContact,
    RemoveContactSuccess,
    Report,
    ReportSuccess,
    SelectContact,
    SendMessage,
    SendMessageFailure,
    SendMessageSuccess,
    SentMessageNotAllowed,
    ToggleSettingsFriendOnly
} from './socket.actions';
import { selectContacts, selectSettings, selectCurrentMessages, selectEarliestMessage, selectedContact, selectLatestMessage, selectLoadingContacts, selectLoadingMessages, selectMessages, selectHasUnreadMessage, selectConcatsHasUnreadMessage, selectCurrentMessagesGroupByDateTime, selectCurrentImages, selectBlocked } from "./socket.selector";

@Injectable()

export class SocketFacade {

    contacts$ = this.store.pipe(select(selectContacts));
    settings$ = this.store.pipe(select(selectSettings));
    loadingMessages$ = this.store.pipe(select(selectLoadingMessages));
    loadingContacts$ = this.store.pipe(select(selectLoadingContacts));
    selectedContact$ = this.store.pipe(select(selectedContact));
    selectEarliestMessage$ = this.store.pipe(select(selectEarliestMessage));
    selectCurrentMessages$ = this.store.pipe(select(selectCurrentMessages));
    selectCurrentImages$ = this.store.pipe(select(selectCurrentImages));
    selectLatestedMessage$ = this.store.pipe(select(selectLatestMessage));
    hasNewMessages$ = this.store.pipe(select(selectHasUnreadMessage));
    concatsHasUnreadMessage$ = this.store.pipe(select(selectConcatsHasUnreadMessage));
    selectCurrentMessagesGroupByDateTime$ = this.store.pipe(select(selectCurrentMessagesGroupByDateTime));
    isUserBlocked$ = this.store.pipe(select(selectBlocked));
    constructor(private store: Store<State>) {

    }

    selectMessage$(uid) {
        return this.store.pipe(select(selectMessages, uid));
    }
    sendMessage(payload: any) {
        this.store.dispatch(new SendMessage(payload));
    }
    sendMessageSuccess(payload: any) {
        this.store.dispatch(new SendMessageSuccess(payload));
    }
    RemoveContact(payload: any) {
        this.store.dispatch(new RemoveContact(payload));
    }
    RemoveContactSuccess(payload: any) {
        this.store.dispatch(new RemoveContactSuccess(payload));
    }
    sendMessageFailure(payload: any) {
        this.store.dispatch(new SendMessageFailure(payload));
    }
    sentMessageNotAllowed(payload: any) {
        this.store.dispatch(new SentMessageNotAllowed(payload));
    }
    receiveMessage(payload: any) {
        this.store.dispatch(new MessageReceived(payload));
    }
    getRecentlyRecords() {
        this.store.dispatch(new GetRecentlyRecords);
    }
    getRecentlyRecordsComplete(payload: any) {
        this.store.dispatch(new GetRecentlyRecordsComplete(payload));
    }
    getRecentlyRecordsByUser(payload: any) {
        this.store.dispatch(new GetRecentlyRecordsByUser(payload));
    }
    getRecentlyRecordsByUserComplete(payload: any) {
        this.store.dispatch(new GetRecentlyRecordsByUserComplete(payload));
    }
    MarkMessagesAsRead(payload) {
        this.store.dispatch(new MarkMessagesAsRead(payload))
    }
    MarkAllMessagesAsRead() {
        this.store.dispatch(new MarkAllMessagesAsRead())
    }
    ClearChatHistory(payload) {
        this.store.dispatch(new ClearChatHistory(payload))
    }
    SelectContact(payload) {
        this.store.dispatch(new SelectContact(payload))
    }
    DeselectContact() {
        this.store.dispatch(new DeselectContact())
    }
    loadPreviousRecords(payload) {
        this.store.dispatch(new LoadPreviousRecords(payload))
    }
    getSettings() {
        this.store.dispatch(new GetSettings())
    }
    getSettingsSuccess(playload) {
        this.store.dispatch(new GetSettingsSuccess(playload))
    }
    toggleSettingsFriendOnly() {
        this.store.dispatch(new ToggleSettingsFriendOnly())
    }
    report(playload: any) {
        this.store.dispatch(new Report(playload))
    }
    reportSuccess() {
        this.store.dispatch(new ReportSuccess())
    }
    getFollowStatus(playload: any) {
        this.store.dispatch(new GetFollowStatus(playload))
    }
    getFollowStatusSuccess(playload: any) {
        this.store.dispatch(new GetFollowStatusSuccess(playload))
    }
    changeFollowStatus(playload: any) {
        this.store.dispatch(new ChangeFollowStatus(playload))
    }
    changeFollowStatusSuccess(playload: any) {
        this.store.dispatch(new ChangeFollowStatusSuccess(playload))
    }
    clearAll() {
        this.store.dispatch(new ClearAll())
    }
    addUserToBlock()
    {
        this.store.dispatch(new AddUserToBlock());
    }
}
